import * as React from "react";
import { Stack } from "@mui/material";
import ConfigurationTable from "../tables/ConfigurationTable";
import ConfigurationFilter from "../filters/ConfigurationFilter";

function Configuration() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ConfigurationFilter/>
            <ConfigurationTable/>
        </Stack>
    )
}

export default Configuration;